import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Inject, PieSeries, AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { FacilityReportSummaryView } from '../../../../services/ReportingService';

interface StaffVsVendorChartProps {
  summaryData: FacilityReportSummaryView;
}

const StaffVsVendorChart: React.FC<StaffVsVendorChartProps> = ({ summaryData }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Staff vs Vendor Breakdown
        </Typography>
        {summaryData.staffRepairCount > 0 || summaryData.vendorRepairCount > 0 ? (
          <AccumulationChartComponent
            id="staff-vendor-breakdown"
            tooltip={{ enable: true }}
            height="300px"
          >
            <Inject services={[PieSeries, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel]} />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={[
                  { category: 'Staff', count: summaryData.staffRepairCount },
                  { category: 'Vendor', count: summaryData.vendorRepairCount },
                ]}
                xName="category"
                yName="count"
                type="Pie"
                innerRadius="40%"
                dataLabel={{ visible: true, position: 'Outside', name: 'category' }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default StaffVsVendorChart;
